// The account menu's "Dark theme" switch (DESIGN-LOG §65). It is the base app's own colour scheme setting
// (localStorage "opencode-color-scheme", the one Settings › Appearance › Color scheme writes), not a new one: on is the
// dark scheme as it shows now (System on a dark Mac included), and a click picks Light or Dark outright.

export type SchemeMode = "light" | "dark"

export function darkSwitch(mode: SchemeMode) {
  const on = mode === "dark"
  return { on, next: (on ? "light" : "dark") as SchemeMode }
}
